import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-generic-button',
    templateUrl: './generic-button.component.html',
    styleUrls: ['./generic-button.component.scss'],
})
export class GenericButtonComponent {
    @Input() public disabled = false;

    @Input() public inputText: string;

    @Input() public classes = '';

    @Input() public type = 'button';

    @Output() public buttonClick = new EventEmitter<void>();

    public genericAction(): void {
        this.buttonClick.emit();
    }
}
